import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import categorySecondaryOptionService from "../../../../services/categorySecondaryOptionService";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./models/categorySecondaryOptionTableColumns";

function CategorySecondaryOptionTable() {
  const history = useHistory();
  const {
    location: { pathname },
  } = history;

  const {
    decoMethodsState,
    categoryState,
    categorySecondaryOptionState,
  } = useMastersContext();

  const loadData = async () => {
    await decoMethodsState.fetch();
    await categoryState.fetch();
    await categorySecondaryOptionState.fetch();
  };

  useEffect(() => {
    loadData();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => categorySecondaryOptionState.data || [], [
    categorySecondaryOptionState.data,
  ]);

  const removeHandler = async (id) => {
    if (window.confirm("Are you sure ?") === true) {
      const result = await categorySecondaryOptionService.remove(id);
      if (result.success === true) {
        categorySecondaryOptionState.fetch();
      }
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>Category Secondary Option</h4>
        </div>
        <div className="col d-flex justify-content-end">
          <button
            className="btn btn-sm btn-success"
            onClick={() => history.push(`${pathname}/add`)}
          >
            Add New
          </button>
        </div>
      </div>
      <hr />
      <CrudTable
        loading={categorySecondaryOptionState.loading}
        data={data}
        columns={columns}
        idField="csO_ID"
        onEdit={(id) => history.push(`${pathname}/edit/${id}`)}
        onRemove={(id) => removeHandler(id)}
      />
    </div>
  );
}

export default CategorySecondaryOptionTable;
